<template>
    <div class="flex" style="box-shadow: 0 0 15px rgba(0, 0, 0, 0.161)">
        <div @click="$emit('update:tabindex',5)" :class="getClass(tabindex===5)"
             class="tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark">
            <i class="icon-occhio w-4 text-[12px]"></i>
            <Tooltip class="-translate-y-1">Campi</Tooltip>
        </div>
        <div @click="$emit('toggleExpand')"
             class="tooltip-activator bg-white py-2 px-7 hover:text-next-orange relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark">
            <i class="icon-freccia_diagonale h-4"></i>
            <Tooltip class="-translate-y-1">Espandi/Collassa</Tooltip>
        </div>
        <div @click="$emit('update:tabindex',0)" :class="getClass(tabindex===0)"
             class="tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark">
            <i class="icon-info h-4"></i>
            <Tooltip class="-translate-y-1">Info Sottoprogetto</Tooltip>
        </div>
        <router-link :to="{name: 'VersioniSottoProgetto', params:{id}}"
                     class="tooltip-activator bg-white py-2 px-7 hover:text-next-orange relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark">
            <i class="icon-orologio_freccia h-4"></i>
            <Tooltip class="-translate-y-1">Versioni</Tooltip>
        </router-link>
        <div @click="$emit('update:tabindex',1)" :class="getClass(tabindex===1)"
             class="tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark">
            <i class="icon-flag h-4"></i>
            <Tooltip class="-translate-y-1">Versione manuale</Tooltip>
        </div>
        <div @click="$emit('update:tabindex',2)" :class="getClass(tabindex===2)"
             class="tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark">
            <i class="rotate-180 icon-upload h-4"></i>
            <Tooltip class="-translate-y-1">Esporta</Tooltip>
        </div>
        <div @click="$emit('update:tabindex',3)" :class="getClass(tabindex===3)"
             class="tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark">
            <i class="icon-calcolatrice h-4"></i>
            <Tooltip class="-translate-y-1">Fee/Rebate/Markup</Tooltip>
        </div>
        <div @click="$emit('update:tabindex',4)" :class="getClass(tabindex===4)"
             class="tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark">
            <i class="icon-euro_frecce h-4"></i>
            <Tooltip class="-translate-y-1">Valute</Tooltip>
        </div>
        <div @click="$emit('update:tabindex',7)" :class="getClass(tabindex===7)"
             class="tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark">
            <i class="icon-upload h-4"></i>
            <Tooltip class="-translate-y-1">Importa</Tooltip>
        </div>
        <div @click="$emit('update:tabindex',8)" :class="getClass(tabindex===8)"
             class="tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark">
            <i class="icon-filtri h-4"></i>
            <Tooltip class="-translate-y-1">Info policy</Tooltip>
        </div>
        <div @click="$emit('update:tabindex',9)" :class="getClass(tabindex===9)"
             class="tooltip-activator py-2 px-7 relative flex items-center justify-center cursor-pointer border-r border-next-gray-md-dark">
            <i class="icon-tre_rettangoli h-4"></i>
            <Tooltip class="-translate-y-1">Sconto</Tooltip>
        </div>
        <div @click="$emit('update:tabindex',6)" :class="getClass(tabindex===6)"
             class="tooltip-activator bg-white py-2 px-7 hover:text-next-orange relative flex items-center justify-center cursor-pointer">
            <i class="icon-biforcazione h-4"></i>
            <Tooltip class="-translate-y-1">Storico vendite</Tooltip>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import Tooltip from "@/components/Tooltip.vue";

@Options({
    name: 'ToolbarSottoProgetto',
    components: {Tooltip},
    props: {
        id: [String, Number],
        tabindex: Number
    }
})
export default class ToolbarSottoProgetto extends Vue {
    getClass(sel: boolean) {
        return sel ? 'bg-next-orange text-white hover:text-white' : 'bg-white hover:text-next-orange'
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
